import { MessageBox } from 'element-ui'
import { sourceURL } from './baseURL'

const CryptoJS = require('crypto-js')
const key = CryptoJS.enc.Utf8.parse('0td34a75152368t4')

/**
 *  加密
 */
export const aesEncrypt = result => {
  if (!result) return ''
  const srcs = CryptoJS.enc.Utf8.parse(result)
  return CryptoJS.AES.encrypt(srcs, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  }).toString()
}

/**
 *  解密
 */
export const aesDecrypt = result => {
  if (!result) return ''
  const resultStr = CryptoJS.enc.Base64.parse(result)
  const encryptedBase64Str = CryptoJS.enc.Base64.stringify(resultStr)
  const decrypt = CryptoJS.AES.decrypt(encryptedBase64Str, key, {
    mode: CryptoJS.mode.ECB, // ECB CBC
    padding: CryptoJS.pad.Pkcs7 // Pkcs7
  })
  // return decrypt.toString(CryptoJS.enc.Utf8)
  const str = CryptoJS.enc.Utf8.stringify(decrypt).toString()
  return str
}

export const imgPathFn = img => {
  return img ? `${sourceURL}/Image/${img}` : require('imgs/modules/default-cover.webp')
}
export const imgPathEmpty = img => {
  return img ? `${sourceURL}/Image/${img}` : ''
}

export const filePathFn = file => {
  return file ? `${sourceURL}/Files/${file}` : ''
}

/**
 * 页面背景/标题背景/主题图片资源
 * @param {String} img
 * @returns String
 */
export const themeConfigureImgUrl = img => {
  return img ? `${sourceURL}/PageBg/${img}` : ''
}

/**
 * @param {Object} config 弹框参数
 * @param {Function} callback 回调函数
 */
export const MessageBoxF = (config, callback) => {
  const confirm_val = true
  const cancel_val = false
  const { msg, confirmText = '确认', cancelText = '取消', type = 'warning' } = config
  MessageBox.confirm(msg, {
    confirmButtonText: confirmText,
    cancelButtonText: cancelText,
    type: type
  }).then(() => {
    callback(confirm_val)
  }).catch(() => {
    callback(cancel_val)
  })
}

/**
 * @description 转为万
 * @param {*} num
 * @returns string
 */
export const ellipsisText = num => num > 9999 ? (num / 10000).toString().substring(0, 4) + '万' : num

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0 || !time) {
    return ''
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string')) {
      if ((/^[0-9]+$/.test(time))) {
        // support "1548221490638"
        time = parseInt(time)
      } else {
        // support safari
        // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
        time = time.replace(new RegExp(/-/gm), '/')
      }
    }

    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value ] }
    return value.toString().padStart(2, '0')
  })
  return time_str
}

export const textLenHandler = (text, len = 6, carry = 0) => {
  if (text) return text.length > len ? text.slice(0, len - carry) + '...' : text
}

export const getFileType = fileName => fileName ? fileName.substring(fileName.lastIndexOf('.') + 1) : ''

export const getFileName = fileName => fileName ? fileName.substring(fileName.lastIndexOf('.')) : ''

/**
 * @description 数字转中文
 * @param {number} num
 * @returns string
 */
export const changeNumToZhCn = num => {
  var arr1 = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']
  var arr2 = ['', '十', '百', '千', '万', '十', '百', '千', '亿', '十', '百', '千', '万', '十', '百', '千', '亿']
  if (!num || isNaN(num)) return '零'
  var english = num.toString().split('')
  var result = ''
  for (var i = 0; i < english.length; i++) {
    var des_i = english.length - 1 - i// 倒序排列设值
    result = arr2[i] + result
    var arr1_index = english[des_i]
    result = arr1[arr1_index] + result
  }
  result = result.replace(/零(千|百|十)/g, '零').replace(/十零/g, '十') // 将【零千、零百】换成【零】 【十零】换成【十】
  result = result.replace(/零+/g, '零') // 合并中间多个零为一个零
  result = result.replace(/零亿/g, '亿').replace(/零万/g, '万') // 将【零亿】换成【亿】【零万】换成【万】
  result = result.replace(/亿万/g, '亿') // 将【亿万】换成【亿】
  result = result.replace(/零+$/, '') // 移除末尾的零
  // 将【一十】换成【十】
  result = result.replace(/^一十/g, '十')
  return result
}

export const richTextImgHandler = richText => {
  if (richText) {
    const regex = new RegExp('<img', 'gi')
    return richText.replace(regex, `<img style="max-width: 100%; height: auto"`)
  } else return ''
}

/**
 * @param {Number} ms 毫秒
 */
export const changeSeconds = (ms, type = 'arr') => {
  // const seconds = Number(ms) / 1000
  // const hours = Math.floor(seconds / 3600)
  // const minutes = Math.floor((seconds % 3600) / 60)
  // return [hours, minutes]

  if (ms) {
    const value = Number(ms) / 1000
    const result = parseInt(value)
    const hours = Math.floor(result / 3600) < 10 ? '0' + Math.floor(result / 3600) : Math.floor(result / 3600)
    const minutes = Math.floor((result / 60 % 60)) < 10 ? '0' + Math.floor((result / 60 % 60)) : Math.floor((result / 60 % 60))
    const seconds = Math.floor((result % 60)) < 10 ? '0' + Math.floor((result % 60)) : Math.floor((result % 60))

    // eslint-disable-next-line eqeqeq
    return type == 'arr' ? [hours, minutes, seconds] : `${hours}:${minutes}:${seconds}`
  }
  // let res = ''
  // if(h !== '00') res += `${h}h`
  // if(m !== '00') res += `${m}min`
  // res += `${s}s`
  // return res
}

/**
 * @description 获取富文本的纯文字内容
 * @param {string} richCont
 * @returns string
 */
export const filtersRichtext = richCont => {
  // 转意符换成普通字符
  function convertIdeogramToNormalCharacter(val) {
    const arrEntities = {
      'lt': '<', 'gt': '>', 'nbsp': ' ', 'amp': '&', 'quot': '"', 'ldquo': '“', 'rdquo': '”', 'mdash': '-', 'deg': '°'
    }
    return val.replace(/&(lt|gt|nbsp|amp|quot|ldquo|rdquo|mdash|deg);/ig, function(all, t) { return arrEntities[t] })
  }
  // const str = richCont
  let value = richCont
  if (richCont) {
    // 方法一：
    value = value.replace(/\s*/g, '') // 去掉空格
    value = value.replace(/<[^>]+>/g, '') // 去掉所有的html标记
    value = value.replace(/↵/g, '') // 去掉所有的↵符号
    value = value.replace(/[\r\n]/g, '') // 去掉回车换行
    value = value.replace(/&nbsp;/g, '') // 去掉空格
    value = convertIdeogramToNormalCharacter(value)
    return value

    // 方法二：
    // value = value.replace(/(\n)/g, "");
    // value = value.replace(/(\t)/g, "");
    // value = value.replace(/(\r)/g, "");
    // value = value.replace(/<\/?[^>]*>/g, "");
    // value = value.replace(/\s*/g, "");
    // value = convertIdeogramToNormalCharacter(value);
    // return value;
  } else {
    return ''
  }
}

/**
 * 文字高亮
 * @param {string} text 原文字
 * @param {string} highLightText 高亮文字
 * @returns html
 */
export const hightText = (text, highLightText, cutText = 0) => {
  if (text) {
    if (cutText) cutText = text && text.length > 15 ? `${text.slice(0, 15)}...` : text

    const reg = new RegExp((`(${highLightText})`), 'gm')
    const replace = '<span style="color: #70B19C;">$1</span>'
    return cutText ? cutText.replace(reg, replace) : text.replace(reg, replace)
  }
}

export const debounce = (func, wait = 800) => {
  let timeout
  return function() {
    const context = this
    const args = [...arguments]
    if (timeout) clearTimeout(timeout)
    timeout = setTimeout(() => {
      func.apply(context, args)
    }, wait)
  }
}
/**
 * @param {*} val
 * @return {String} val type
 */
export const getValType = (val) => {
  const class2type = {}
  'Boolean Number String Function Array Date RegExp Object Error'.split(' ').map((item, idx) => {
    class2type[`[object ${item}]`] = item.toLowerCase()
  })
  if (val == null) return val + ''
  return typeof val === 'object' || typeof val === 'function'
    ? class2type[Object.prototype.toString.call(val)] || 'object'
    : typeof val
}

/**
 * @param {*} time MM-mm-dd HH:mm:ss
 * @returns 毫秒
 */
export const timeToSc = time => {
  if (!time) return ''
  const times = time.replace(/-/g, '/')
  return (Date.parse(times)) / 3600 / 1000
}
